<div class="wrap">
  <h2>{{data.text}}</h2>

  <div class="btn_action">
    <button class="confirm" (click)="dialogRef.close()" appChangeColorTheme attribute="bgc">Fermer</button>
  </div>

</div>
